import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@sitebase/theme-context';
import { MediaProvider } from '@sitebase/media-context';
import { TranslatorProvider } from '@wh/ui-translations';

import App from './App';
import { BREADCRUMBS_V2_ID, DEFAULT_PLATFORM } from '../../../constants';

import '@sitebase/ui-kit/styles.css';

const platformsTouchable = new Set(['mobile', 'tablet', 'native']);

const AppDecorator = ({ translations, platform = DEFAULT_PLATFORM, ...props }) => {
    const isTouchable = platformsTouchable.has(platform);

    return (
        <div id={BREADCRUMBS_V2_ID}>
            <ThemeProvider theme="dark">
                <MediaProvider device={platform} touchable={isTouchable}>
                    <TranslatorProvider translations={translations}>
                        <App {...props} isTouchable={isTouchable} />
                    </TranslatorProvider>
                </MediaProvider>
            </ThemeProvider>
        </div>
    );
};

AppDecorator.propTypes = {
    translations: PropTypes.object.isRequired,
    platform: PropTypes.string,
};

export default AppDecorator;
